import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function Admin({ user }) {
  const [pending, setPending] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [tab, setTab] = useState('pending');
  const [loading, setLoading] = useState('');

  useEffect(()=>{
    const load = async () => {
      const pq = query(collection(db,'users'),where('status','==','pending'));
      const ps = await getDocs(pq);
      setPending(ps.docs.map(d=>({id:d.id,...d.data()})));
      const aq = query(collection(db,'users'));
      const as_ = await getDocs(aq);
      setAllUsers(as_.docs.map(d=>({id:d.id,...d.data()})));
    };
    load();
  },[]);

  const approve = async (uid) => {
    setLoading(uid);
    await updateDoc(doc(db,'users',uid),{status:'approved',approved:true});
    setPending(p=>p.filter(u=>u.id!==uid));
    setAllUsers(u=>u.map(x=>x.id===uid?{...x,status:'approved',approved:true}:x));
    setLoading('');
  };

  const reject = async (uid) => {
    setLoading(uid+'r');
    await updateDoc(doc(db,'users',uid),{status:'rejected',approved:false});
    setPending(p=>p.filter(u=>u.id!==uid));
    setAllUsers(u=>u.map(x=>x.id===uid?{...x,status:'rejected'}:x));
    setLoading('');
  };

  return (
    <div style={{minHeight:'100vh',background:'#F0FDF4'}}>
      <nav className="nav">
        <Link className="nav-brand" to="/"><div className="nav-logo">🏘</div><div className="nav-name">Community<span>Bridge</span></div></Link>
        <div className="nav-links">
          <Link to="/dashboard" className="nav-link">Dashboard</Link>
          <Link to="/admin" className="nav-link active">Admin</Link>
        </div>
      </nav>
      <div className="page">
        <h1 className="page-title">🛡️ Admin Panel</h1>
        <p className="page-sub">Manage users, approvals and community safety</p>

        <div className="grid4" style={{marginBottom:'2rem'}}>
          {[{icon:'⏳',num:pending.length,label:'Pending Approval'},{icon:'✅',num:allUsers.filter(u=>u.status==='approved').length,label:'Approved'},{icon:'👥',num:allUsers.length,label:'Total Users'},{icon:'❌',num:allUsers.filter(u=>u.status==='rejected').length,label:'Rejected'}].map((s,i)=>(
            <div key={i} className="stat-card">
              <div style={{fontSize:'28px',marginBottom:'6px'}}>{s.icon}</div>
              <div className="stat-num">{s.num}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        <div style={{display:'flex',gap:'8px',marginBottom:'1.5rem'}}>
          {['pending','all'].map(t=>(
            <button key={t} className={`btn ${tab===t?'btn-primary':'btn-gray'}`} onClick={()=>setTab(t)}>
              {t==='pending'?`⏳ Pending (${pending.length})`:'👥 All Users'}
            </button>
          ))}
        </div>

        <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
          {(tab==='pending'?pending:allUsers).map(u=>(
            <div key={u.id} className="card" style={{padding:'1.25rem'}}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:'12px'}}>
                <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
                  <div style={{width:'48px',height:'48px',borderRadius:'50%',background:'linear-gradient(135deg,#16A34A,#EA580C)',display:'flex',alignItems:'center',justifyContent:'center',color:'white',fontSize:'20px',fontWeight:800,flexShrink:0}}>
                    {(u.name||'U')[0].toUpperCase()}
                  </div>
                  <div>
                    <p style={{fontWeight:700,fontSize:'15px'}}>{u.name}</p>
                    <p style={{fontSize:'12px',color:'#6B7280'}}>{u.email} · {u.phone}</p>
                    <p style={{fontSize:'12px',color:'#6B7280'}}>📍 {u.city}, {u.state}, {u.country} · {u.postcode}</p>
                    <div style={{display:'flex',gap:'6px',marginTop:'4px',flexWrap:'wrap'}}>
                      <span className={`badge ${u.role==='volunteer'?'badge-green':u.role==='organizer'?'badge-blue':'badge-orange'}`}>{u.role}</span>
                      <span className={`badge ${u.status==='approved'?'badge-green':u.status==='pending'?'badge-orange':'badge-red'}`}>{u.status}</span>
                    </div>
                  </div>
                </div>
                {u.status==='pending' && (
                  <div style={{display:'flex',gap:'8px'}}>
                    <button className="btn btn-primary" style={{fontSize:'13px'}} onClick={()=>approve(u.id)} disabled={loading===u.id}>
                      {loading===u.id?'...':'✅ Approve'}
                    </button>
                    <button className="btn btn-danger" style={{fontSize:'13px'}} onClick={()=>reject(u.id)} disabled={loading===u.id+'r'}>
                      {loading===u.id+'r'?'...':'❌ Reject'}
                    </button>
                  </div>
                )}
                {u.status==='approved' && <span className="badge badge-green">✅ Approved</span>}
                {u.status==='rejected' && <span className="badge badge-red">❌ Rejected</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
